import { useState } from "react";
import type { QuestionSettings, QuestionType } from "@/types/question";
import { createEmptySelectionOptions } from "../constants/questionDefaults";

export type QuestionTypeOrChecklist = QuestionType | 999;

export type QuestionOption = {
	id: string;
	text: string;
	icon?: React.ComponentType<{ className?: string }>;
};

export const useQuestionForm = () => {
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [selectedType, setSelectedType] =
		useState<QuestionTypeOrChecklist | null>(null);
	const [settings, setSettings] = useState<QuestionSettings>({});
	const [options, setOptions] = useState<QuestionOption[]>(
		createEmptySelectionOptions()
	);

	const handleAddOption = () => {
		const newOption: QuestionOption = {
			id: Date.now().toString(),
			text: "",
		};
		setOptions([...options, newOption]);
	};

	const handleUpdateOption = (id: string, text: string) => {
		setOptions(
			options.map((option) => (option.id === id ? { ...option, text } : option))
		);
	};

	const handleDeleteOption = (id: string) => {
		setOptions(options.filter((option) => option.id !== id));
	};

	const handleReorderOptions = (fromIndex: number, toIndex: number) => {
		if (
			fromIndex === toIndex ||
			fromIndex < 0 ||
			toIndex < 0 ||
			fromIndex >= options.length ||
			toIndex >= options.length
		) {
			return;
		}

		const nextOptions = [...options];
		const [moved] = nextOptions.splice(fromIndex, 1);
		if (!moved) {
			return;
		}
		nextOptions.splice(toIndex, 0, moved);
		setOptions(nextOptions);
	};

	return {
		title,
		setTitle,
		description,
		setDescription,
		selectedType,
		setSelectedType,
		settings,
		setSettings,
		options,
		setOptions,
		handleAddOption,
		handleUpdateOption,
		handleDeleteOption,
		handleReorderOptions,
	};
};
